export default __webpack_public_path__ + "images/34cd003bd0ba104faf21be905ca3ac7e.jpg";